import { Typography } from "@material-ui/core"
import { StyledLink } from "reusable/wrappers/BodyText"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  display: flex;
  align-items: center;
  max-width: 1400px;
  padding: 100px;
  p {
    margin-top: 10px;
  }
  h6 {
    margin-top: 10px;
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column-reverse;
    padding: 0px;
    padding-top: 70px;
    padding-bottom: 50px;
    padding-left: 16px;
    padding-right: 16px;
  }
  }
`
const StyledWrapper = styled.div`
  width: 50%;
  height: 100%;
  img {
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 549px;
      height: 364px;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledImage = styled.img`
  width: 100%;
`

const Page500 = () => {
  return (
    <StyledPageWrapper $padding={"0"} $background="#F5F5F5">
      <StyledPageDiv>
        <StyledWrapper>
          <Typography variant="h2">משהו השתבש</Typography>
          <Typography variant="subtitle1">
            משהו לא עובד ואנחנו עובדים על לתקן את זה.
          </Typography>
          <Typography variant="body1">
            {" "}
            אם זה עניין דחוף ניתן להתקשר{" "}
            <StyledLink $color=" #101010">לשירות הלקוחות שלנו</StyledLink>
          </Typography>
          <Typography variant="body1">
            בבקשה נסו שוב מאוחר יותר, <br></br>סליחה ותודה על הסבלנות.
          </Typography>
        </StyledWrapper>
        <StyledWrapper>
          <StyledImage src={"/img/500.png"} />
        </StyledWrapper>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default Page500
